<template>
  <div class="mainPage">
    <div class="header_banner">
      <img src="../img/chineseCultureVideoExhibition/2026/m/header.png" alt="央视精品节目展播" class="banner_img" />
    </div>
    <div class="content">
      <div class="rightBox">
        <div class="projectProfile">
          <div class="box">
            <div class="text">
              在第十七个联合国中文日到来之际，我们将面向海外中文学习者及中国文化爱好者，特别推出2026“魅力中文”联合国中文日展播，带您欣赏中央广播电视总台制作的精品节目。在微短剧《舞动敦煌》《墨韵新生》《顾盼锦年》中，感受中华传统艺术的灵动与新生；在《成语探华夏》《“字”从遇见你》（第三季）、“中文轻松学”融媒体汉语教学节目中，发现学习中文的乐趣；在《中国民间故事》《远方的童谣》《传世古建》《中华考工记》《宗师列传·大唐诗人传》《简牍探中华》（第二季）中，沉浸式体验中华文化的多元魅力。
            </div>
            <div class="text2">
              On the occasion of the 17th United Nations Chinese Language Day, we will specially launch the 2026
              "Charming Chinese" UN Chinese Language Day Screening Series around April 20 for overseas Chinese language
              learners and Chinese culture enthusiasts, presenting a selection of high-quality programs produced by
              China Media Group (CMG).In the short dramas Dunhuang in Motion, Ink Rhythm Reborn and Glances Through
              Splendid Years, you will feel the dynamism and revitalization of traditional Chinese art.In Idioms Uncover
              China, The Story of Characters (Season 3) and the integrated media Chinese learning program "Easy
              Chinese", you will discover the joy of learning Chinese.In Chinese Folktales, Distant Nursery Rhymes,
              Timeless Ancient Architecture, Chinese Crafts in Time, Biographies of Great Masters: Poets of the Tang
              Dynasty and Bamboo and Wooden Slips: Exploring China (Season 2), you can immerse yourself in the diverse
              splendor of Chinese culture.
            </div>
          </div>
        </div>

        <div class="classBox_wrap">
          <div class="classBox" v-for="subject in subject_info" :key="subject.id">
            <div class="classBox1">
              <div class="titleBox"></div>
              <!-- 手机端视频集合 -->
              <div class="swiper_wrap">
                <div class="swiper_con">
                  <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                    <swiper-slide v-for="(v, index) in subject.courseList" :key="index">
                      <div class="video_con" :data-info="v.name" @click="goDetail(subject, index)">
                        <div class="video_cover">
                          <img :src="v.cover_url" :alt="v.video_url" class="cover" />
                        </div>
                      </div>
                    </swiper-slide>
                    <!-- 占位：当没有课程数据时，保留与视频区域等高的位置，避免布局塌陷 -->
                    <div v-if="
                      !subject.courseList || subject.courseList.length === 0
                    " class="swiper_placeholder"></div>
                    <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
                  </swiper>
                  <div class="info_left">
                    <div class="serise_icon_con">
                      <img :src="subject.image_url || subject.extra.schoolLogo" alt="" class="look_detail_icon" />
                    </div>
                    <div class="name_con">
                      <p class="cn">{{ subject.name }}</p>
                      <p class="en">{{ subject.name_en }}</p>
                    </div>
                  </div>
                </div>
                <div class="text_wrap">
                  <div class="swiper_page"></div>
                  <div class="text_cn">
                    {{ subject.describe }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay" @mousewheel.prevent>
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <div class="videoContainer">
            <video :src="currentVideoUrl" id="liveVideo" controls autoplay controlsList="nodownload">
            </video>
          </div>
        </div>
      </div>
    </transition>

    <div id="menuGuide" v-show="isShowGuide" @click="showDirectory()" @mousewheel.prevent></div>

  </div>
</template>

<script>
export default {
  name: 'm_chinese_Culture_Video_Exhibition_2026',
  metaInfo() {
    return {
      title: "2026魅力中文,中央广播电视总台精品节目展播",
      meta: [
        {
          name: "keyword",
          content: "2026魅力中文,中央广播电视总台,精品节目展播",
        },
        {
          name: "description",
          content: "2026魅力中文 中央广播电视总台精品节目展播",
        },
      ],
    };
  },
  data: () => {
    return {
      isPlay: false,
      currentVideoUrl: '',
      isShowGuide: false,
      subjectList: new Array(14).fill().map((_, i) => `chinese_Culture_Video_Exhibition_2026_${i + 1}`),
      subject_info: [],
      //手机端
      swiperOptionTop: {
        loopedSlides: 5,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom">${index + 1}</span>`
          }
        }
      },
      showDetail: false,
    }
  },
  created() {
    // 专题获取数据
    this.getCollectList()
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener("scroll", this.onScroll, false);
  },
  destroy() {
    // 移除监听器
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    showDirectory() {
      this.isShowGuide = !this.isShowGuide
    },
    goDetail(item, i) {
      this.$router.push({
        path: '/m_page/m_cmgp2026_detail',
        query: {
          collection_id: item.id,
          videoIndex: i
        }
      })
    },
    async getAllInfo() {
      this.subject_info.forEach((item) => {
        this.getSubjectInfo(item);
      });
    },
    getCollectList() {
      this.$utils.get("/subject/lesson_Collection/getlist", {
        limit: 999,
        alias: 'cmgp2026',
      })
        .then((res) => {
          if (res.data.success) {
            this.subject_info = res.data.data.list
            this.getAllInfo()
          }
        })
    },
    // 获取专题信息
    getSubjectInfo(item) {
      this.$utils
        .get("/subject/lesson/getlist", {
          collection_id: item.id,
          order: 'sort',
          limit: 30
        })
        .then((res) => {
          if (res.data.success) {
            item.courseList = res.data.data.list
            this.$forceUpdate()
          }
        })
    },
    //播放课程
    replay(url, cover) {
      // console.log(url)
      this.currentVideoUrl = url;
      this.imgUrl = cover;
      this.isPlay = true;
      setTimeout(function () {
        //
        $("#liveVideo").bind("contextmenu", function () {
          return false;
        }); //为video添加禁止右键另存为操作
      }, 50);
    },
    closeVideo() {
      var myvideo = document.getElementById("liveVideo");
      if (!myvideo.paused) {
        //视频正在播放中时停止播放
        myvideo.pause();
      }
      this.isPlay = false;
    },
  }
}
</script>


<style scoped lang="scss">
.mainPage {
  width: 100%;
  text-align: center;
  position: relative;
  min-height: 100vh;
  user-select: none;
  overflow: hidden;

  .header_banner {
    position: relative;
    width: 100%;
    height: 4.42rem;
    overflow: hidden;

    .banner_img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
      object-position: center;
    }
  }

  .content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: -0.92rem auto 0;

    .leftBox {
      position: fixed;
      top: 50px;
      right: 0px;
      background-color: #fff;
      border-radius: 5px 0 0 5px;
      box-shadow: -5px 5px 20px 0px #888888;
      text-align: end;
      z-index: 10000;

      .box {
        display: flex;
        flex-direction: column;
        margin-right: 30px;
        margin-left: 20px;
        margin-top: 20px;
        margin-bottom: 20px;

        .titleBox {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          cursor: pointer;

          .title {
            padding: 7px 10px;
            display: flex;
            flex-direction: column;
            margin-right: 45px;

            .title_cn {
              font-size: 18px;
              line-height: 30px;
            }

            .title_en {
              font-size: 12px;
              font-family: DINCond-Medium;
            }

          }
        }

        .titleBox.active {
          .title {
            color: darkorange;
            margin-right: 45px;
          }
        }
      }

      .icon {
        position: absolute;
        bottom: 57px;
        right: 15px;
        width: 40px;
        height: 0px;

        img {
          width: 100%;
        }
      }

    }

    .rightBox {
      width: 100%;
      display: flex;
      flex-direction: column;

      .projectProfile {
        .box {
          box-sizing: border-box;
          padding: .4rem .34rem 1.9rem;
          width: 100%;
          border-radius: .2rem;
          background-color: #fff;
          box-shadow: 0rem .03rem .1rem 0rem #0000001A;
          font-family: Microsoft YaHei;
          color: #000;
          font-weight: 400;
          letter-spacing: 0%;
          text-align: start;
          font-size: .28rem;

          .text {
            margin-bottom: .2rem;
            line-height: .4rem;
          }

          .text2 {
            line-height: .4rem;
          }
        }
      }


      .classBox_wrap {
        margin-top: -1.5rem;

        .classBox {
          position: relative;
          padding: 0;

          .titleBox {
            width: auto;
            height: 1.2rem;
            position: absolute;
            z-index: 10;
            top: -0.8rem;
            left: -0.1rem;

            img {
              width: auto;
              height: 100%;
            }
          }

          .text {
            margin-top: 1.3rem;
            padding: 10px 15px 20px;
            text-align: justify;
          }

          .text_cn {
            font-size: 0.3rem;
            color: #5e696d;
            line-height: 24px;
            margin-top: 0.5rem;
            margin-bottom: 5px;
            text-align: left;
            text-indent: 2em;
          }

          .text_en {
            font-size: 0.3rem;
            color: #5e696d;
            line-height: 20px;
            text-align: left;
          }

          .info_left {
            position: absolute;
            left: 0.3rem;
            right: 0.3rem;
            top: 3.64rem;
            z-index: 10000;
            display: flex;
            align-items: flex-start;

            .serise_icon_con {
              border: solid 0.03rem #ffffff;
              flex-shrink: 0;

              img {
                border-radius: 6px;
                width: 1.5rem;
                height: 1.5rem;
                display: block;
              }
            }

            .name_con {
              flex: 1;
              margin-top: 0.4rem;
              margin-left: 0.25rem;
              text-align: left;
              white-space: normal;
              word-break: break-word;
              overflow-wrap: anywhere;

              .cn {
                font-family: SourceHanSansCN;
                font-weight: bold;
                font-size: 0.4rem;
                color: #364347;
                margin-bottom: 0.1rem;
                white-space: normal;
                word-break: break-word;
                overflow-wrap: anywhere;
                line-height: 0.5rem;
              }

              .en {
                font-family: SourceHanSansCN;
                font-weight: bold;
                font-size: 0.26rem;
                color: #93a4aa;
                white-space: normal;
                word-break: break-word;
                overflow-wrap: anywhere;
                line-height: 0.2rem;
              }
            }
          }

          .swiper_wrap {
            background-color: #fff;

            .swiper_con {
              margin-left: 0;
              position: relative;
              padding: 0 0.15rem;

              .swiper_placeholder {
                width: 100%;
                height: 4rem;
                background: transparent;
              }

              .swiper-container {
                position: unset;
              }

              .swiper ::v-deep {
                .swiper-slide {
                  .swiperBox {
                    overflow: hidden;
                  }
                }

                .video_con {
                  width: 100%;
                  box-sizing: border-box;
                  padding: 0;

                  .video_cover {
                    width: 100%;
                    aspect-ratio: 16 / 9;
                    background-color: #ffae00;

                    img {
                      display: block;
                      width: 100%;
                      height: 100%;
                      cursor: pointer;
                    }
                  }

                  .playBtn {
                    position: absolute;
                    width: 0.8rem;
                    height: 0.9rem;
                    bottom: 1rem;
                    right: 0.4rem;
                    z-index: 10;
                    animation: my-animation 1.5s ease-in-out infinite;

                    @keyframes my-animation {
                      0% {
                        transform: scale(0.8);
                      }

                      50% {
                        transform: scale(1);
                      }

                      100% {
                        transform: scale(0.8);
                      }
                    }
                  }

                  .titleBox1 {
                    position: absolute;
                    height: 55px;
                    margin-top: -55px;
                    width: 100%;
                    color: #fff;
                    background-color: #55565775;
                    text-align: left;
                    bottom: 0;
                    z-index: 100;
                    display: flex;
                    align-items: center;

                    .course_title {
                      padding: 10px 20px;

                      .cn {
                        font-size: 16px;
                      }

                      .en {
                        margin-top: 4px;
                        font-size: 14px;
                      }
                    }
                  }
                }

                .video_con2 {
                  width: 1rem;
                  background-color: #c40000;

                  .checkBox {
                    width: 1rem;
                    height: 1rem;
                    background-color: #ffae00;
                  }
                }

                .swiper-pagination {
                  position: static !important;
                  margin-top: 1.7rem;
                  left: auto;
                  right: auto;
                }

                .swiper-pagination-bullets {
                  bottom: auto;
                  text-align: left;
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  margin-left: 10px;

                  .swiper-pagination-bullet-custom {
                    border-radius: 0.14rem;
                    border: 1px solid #ba9f7d;
                    width: 0.7rem !important;
                    height: 0.7rem !important;
                    line-height: 0.7rem !important;
                    text-align: center;
                    color: #a1896b;
                    background-image: linear-gradient(0deg, #e7d9ce 0%, #f8f4f1 100%);
                    transition: all 0.5s;
                    margin-right: 0.1rem;
                    margin-top: 4px;
                    opacity: 1;

                    &.swiper-pagination-bullet-active {
                      opacity: 1;
                      color: #eb7f66;
                      border: solid 1px #eb7f66;
                      background: rgba(#fceeeb, 0.6);
                    }
                  }
                }
              }

              .gallery-top {
                width: 100%;
                height: auto;
              }

              .gallery-thumbs {
                height: 20%;
                box-sizing: border-box;
                width: 1rem;
              }

              .gallery-thumbs .swiper-slide {
                height: 100%;
                opacity: 0.4;
                width: 1rem !important;
              }

              .gallery-thumbs .swiper-slide-active {
                opacity: 1;
              }

              .swiper-button-prev {
                background-image: url(../img/chineseCultureVideoExhibition/2026/prev.png);
                position: absolute;
                left: -75px;
                top: 90px;
              }

              .swiper-button-next {
                background-image: url(../img/chineseCultureVideoExhibition/2026/next.png);
                right: -75px;
                top: 90px;
              }
            }

            .text_wrap {
              padding: 0 0.3rem 0.4rem 0.3rem;
            }
          }

          .series_type2_con {
            overflow: hidden;
            background-color: #fff;
            border-radius: 0.1rem;

            .cover_con {
              width: 10.28rem;
              height: 5.8rem;
              display: block;
              margin-right: 22px;
            }

            .cover {
              display: block;
              width: 100%;
              height: 100%;
            }

            .des_con {
              font-size: 0.3rem;
              color: #5e696d;
              line-height: 1;
              text-align: left;
              margin-top: 0.5rem;
              padding: 0 0.3rem 0.4rem 0.3rem;

              .cn {
                text-indent: 2em;
                margin-bottom: 0.2rem;
                margin-top: 0.2rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                line-clamp: 4;
                overflow: hidden;
              }

              .en {
                display: -webkit-box;
                -webkit-box-orient: vertical;

                -webkit-line-clamp: 5;
                line-clamp: 5;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }


  #videoPlayWrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.88);
    z-index: 9999;
  }

  #menuGuide {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
  }

  #videoPlayWrapper .closeVideo {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 50px;
    color: #fff;
    cursor: pointer;
  }

  .videoContent {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .videoContainer {
    text-align: center;
    width: 100%;
  }

  .videoContainer video {
    width: 100%;
  }

  video::-internal-media-controls-download-button {
    display: none;
  }

  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }

  video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
  }
}
</style>
